<template>
  <span v-if="status" class="tag" :class="status | statusType">
    {{ challenge && status === ONLINE_STATUS.ACTIVE ? "Challenged" : status }}
  </span>
</template>

<script>
import { ONLINE_STATUS } from "../../constants";

export default {
  name: "StatusTag",

  props: ["status", "challenge"],

  data() {
    return { ONLINE_STATUS: ONLINE_STATUS };
  },

  filters: {
    statusType(status) {
      switch (status) {
        case ONLINE_STATUS.ACTIVE:
          return "is-success";
        case ONLINE_STATUS.AWAY:
          return "is-warning";
        case ONLINE_STATUS.PLAYING:
          return "is-info";
        case ONLINE_STATUS.BUSY:
        case ONLINE_STATUS.OFFLINE:
          return "is-danger";
        default:
          return "";
      }
    },
  },
};
</script>

<style></style>
